import createCustomApp from '@/views/init-app.js';
import MainPage from '@/views/PublicationOverview.vue';

const domId = 'publication-list';

createCustomApp(MainPage, domId);
